export default __webpack_public_path__ + "static/media/qwo.4efd40ac.pdf";